import { get } from 'lodash/fp';

export const getLastLineItemIdAdded = get('lineItems.lastLineItemAdded');
export const getLastLineItemIdAddedCategory = get('lineItems.lastLineItemAddedCategory');
